import { useEffect, useRef, useState } from "react";
import { Mlistar, copyToClipboard, corColunaStatus, fire, getPermissao, toData, toDateTime, permissaoPorListaUsuario } from "../../../../util";
import { Button, Col, Row } from "react-bootstrap-v5";
import MPaging from "../../../components/MPaging/MPaging";
import { tipoPermissao } from "../tipos/tipos";
import { MModal } from "../../../components/MModal/MModal";
import { MInput } from "../../../components/MInput/MInput";
import { getAxios } from "../../../components/net";
import { API_URL } from "../../../components/MConfig";
import Swal from "sweetalert2";
import { FromFormReference } from "../../../components/MForm/MForm";

export const ListaPropostas = props => {

    const paginador = useRef();
    const [dados, setDados] = useState([]);
    const [pix, setPix] = useState([]);
    const modalCancelar = useRef();
    const modalPix = useRef();
    const modalReenviarLink = useRef();
    const [ciente, setCiente] = useState(false);
    const [propostaAtual, setPropostaAtual] = useState(false);
    const [modoDesenv, setModoDesenv] = useState(false);



    const carregar = pagina => Mlistar("/proposta/ListarPropostas", paginador, pagina, null, res => setDados(res));

    const ordenar = (ordem) => Mlistar("/proposta/ListarPropostas", paginador, null, ordem, res => setDados(res));

    const editarCadastro = (e, x) => {
        e?.stopPropagation();
        x.isEdit = true;
        props.editarCadastro(x);
    }

    const permissaoDev = () => permissaoPorListaUsuario([1037]);

    const visualizar = (e, x) => {
        e?.stopPropagation();
        fire.call('visualizar_proposta', x);
    }
    const copiar = (e, x) => {
        if (!x.linkKompletoCliente) {
            Swal.fire("Erro!", "Desculpe,algo errado com o link!!");
        } else {
            copyToClipboard(x.linkKompletoCliente);
            window.modalAlert.Show({ title: "Copiado", message: "Link copiado para a area de transferência", type: "info" });
        }
        e?.stopPropagation();
    }

    const copiarPix = (e, x) => {
        if (!x.pixCopiaCola) {
            Swal.fire("Erro!", "Desculpe,algo errado com o código do Pix!!");
        } else {
            copyToClipboard(x.pixCopiaCola);
            window.modalAlert.Show({ title: "Copiado", message: "PIX copiado para a area de transferência", type: "info" });
        }
        e?.stopPropagation();
    }

    const TemPixPreenchido = (e, x) => {

        if (e?.pixCopiaCola) {
            return true;
        }
        return false;
    }

    const cancelar = (e, x) => {
        modalCancelar.current.Show(x);
        e?.stopPropagation();
    }

    const abrirPix = (e, x) => {
        setPix(x);
        modalPix.current.Show();
        e?.stopPropagation();
    }

    const reenviarLink = (e, x) => {
        modalReenviarLink.current.Show(x);
        e?.stopPropagation();
    }

    const cancelarGovBR = (e, x) => {
        getAxios().post(API_URL + "/proposta/cancelarGovBr/" + x.token, null).then(res => {
            carregar(1);
            Swal.fire("Sucesso!", "Solicitação de cancelamento enviado!", "success");
        }).catch(res => {
            Swal.fire("Erro!", "Ocorreu um erro. informe ao administrador!");
        }).finally(() => {
            window.showWait(false);
        });
    }

    const permissaoReenvio = x => {

        var pode = (x.statusAdicionalId == 9 || x.statusAdicionalId == 7
            || (x.statusAdicionalId == 6 && x.tentativas < 2));

        try {

            const agora = new Date();
            const dataComparar = new Date(x.dataCadastro);

            const diferencaMillis = agora - dataComparar;

            const vinteQuatroHorasMillis = 24 * 60 * 60 * 1000;

            var ins = [9, 7, 6, 2];

            if (!pode && ins.includes(x.statusAdicionalId))
                pode = diferencaMillis > vinteQuatroHorasMillis;


        } catch { }

        return pode;
    }


    const marcarCiente = e => {
        setCiente(e.target.checked);
    }

    const realizarReenvioLink = e => {
        window.showWait(true);
        var dados = FromFormReference(e.current);
        getAxios().post(API_URL + "/proposta/reenviarlink/" + dados.id, null).then(res => {
            carregar(1);
            Swal.fire("Sucesso!", "Solicitação de novo link enviado!", "success");
        }).catch(res => {
            Swal.fire("Erro!", "Ocorreu um erro ao montar link. informe ao administrador!");
        }).finally(() => {
            window.showWait(false);
        });
    }

    const realizarCancelamento = e => {
        var dados = FromFormReference(e.current);
        dados.propostaId = dados.id;
        dados.cpf = dados.cpfenvio;
        delete dados.id;
        setCiente(false);
        getAxios().post(API_URL + "/proposta/cancelar", dados).then(res => {
            Swal.fire("Sucesso!", "Proposta cancelada!", "success");
        }).catch(res => {
            window.showWait(false);
            Swal.fire("Erro!", "<ul>" + JSON.stringify(res.response.data.message).split("\\r\\n").map(x => "<li>" + x + "<li>").join('') + "</ul>");
        });
    }

    const fecharModal = () => {
        setCiente(false);
    }


    useEffect(() => {
        fire.register('filtrar_proposta', e => {
            paginador?.current?.setFilter(e);
        });

        if (props.recarregar) {
            carregar(1);
        }

    }, [])

    useEffect(() => {
        carregar(1);
    }, [props.recarregar])


    const filtroStatus = x => {
        var ret = x.nomeStatus;
        if (x.produtoId == 6 || x.produtoId == 9 || x.produtoId == 10) {
            ret += ' / ' + x.statusAdicional;
        }
        return ret;
    }

    const toolboxPermitido = item => {
        if (item.statusId == 13) return false; //Cancelado
        return true;
    }

    return <>
        <MModal onClickCancel={fecharModal} onClickSave={realizarCancelamento}
            size={1.5} ref={modalCancelar} saveButton={ciente} title="Cancelar Proposta"
            closeText="Fechar" saveText="Confirmar Cancelamento" >
            <i className="fa fa-alert fa-2x"></i>
            <p>Deseja realmente cancelar a proposta <MInput type="label" id="id" /></p>
            <Row>
                <Col>Cpf: <br /> <MInput type="label" id="cpfenvio" /></Col>
                <Col>Cliente: <br /> <MInput type="label" id="nomeCliente" /></Col>
            </Row>
            <input className="mt-5" type="checkbox" onClick={e => marcarCiente(e)} /> Estou ciente, e desejo realmente cancelar.
            {ciente && <>
                <p>Preencha abaixo o motivo do cancelamento:</p>
                <MInput type="area" name="MotivoCancelamento" />
            </>}
            <input type="hidden" name="id" />
        </MModal>

        <MModal saveButton={false} size={2.5} ref={modalPix}
            title="Pix" closeText="Fechar"  >
            <i className="fa fa-alert fa-2x"></i>
            {(!pix?.pixRecorrencia) &&
                <>
                    <p>Pix copia e cola abaixo:</p>
                    <textarea style={{ width: "100%", height: 100 }}>{pix?.pixCopiaCola}</textarea>
                </>
            }
            {pix?.pixRecorrencia &&
                <div>
                    <br />
                    <p>Pix de recorrência abaixo:</p>
                    <textarea style={{ width: "100%", height: 100 }}>{pix?.pixCopiaCola}</textarea>
                </div>
            }
        </MModal>

        <MModal onClickSave={realizarReenvioLink} saveButton={true} size={1.5} ref={modalReenviarLink}
            title="Reenviar Link" closeText="Fechar" saveText="Reenviar" >
            <i className="fa fa-alert fa-2x"></i>
            <p>Deseja realmente reenviar um novo link para o cliente?</p>
            <input type="hidden" name="id" />
        </MModal>
        {
            permissaoDev() && <>
                <span>Modo desenv:</span>
                <input type="checkbox" onChange={() => setModoDesenv(!modoDesenv)} />
            </>
        }
        <div style={{ width: "100%", overflow: "auto" }}>
            <table id="tableList" className="table table-stripelist mt-5">
                <thead>
                    <tr>
                        <td></td>
                        <th>#</th>
                        <th><a href="#" onClick={e => ordenar('NomeCliente')}>Nome</a></th>
                        <th><a href="#" onClick={e => ordenar('Cpf')}>Cpf</a></th>
                        <th><a href="#" onClick={e => ordenar('TelefonePessoal')}>Telefone</a></th>
                        <th><a href="#" onClick={e => ordenar('Produto.NomeExterno')}>Produto</a></th>
                        <th><a href="#" onClick={e => ordenar('StatusId')}>Status</a></th>
                        <th><a href="#" onClick={e => ordenar('RevendedorId')}>Empresa</a></th>
                        <th><a href="#" onClick={e => ordenar('VendedorUsuarioId')}>Vendedor</a></th>
                        <th><a href="#" onClick={e => ordenar('DataCadastro')}>Data</a></th>
                        <th>Acoes</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dados?.resultado?.map(x =>
                            <>
                                <tr className="selecao" key={x.id} onClick={e => visualizar(e, x)}>
                                    <th className={`colunaStatus`} style={{ backgroundColor: corColunaStatus(x.statusId) }} ></th>
                                    <td>{x.id}</td>
                                    <td>{x.nomeCliente}</td>
                                    <td>{x.cpf}</td>
                                    <td>{x.telefonePessoal}</td>
                                    <td>{x.nomeProduto}</td>
                                    <td>{filtroStatus(x)}</td>
                                    <td>{x.nomeRevendedor}</td>
                                    <td>{x.nomeVendedor}</td>
                                    <td>{toDateTime(x.dataCadastro).replace(',', '\n')}</td>
                                    <td style={{ zoom: 0.6 }} className="no-click" >
                                        {toolboxPermitido(x) &&
                                            <table>
                                                <tr>
                                                    <td>
                                                        <td><Button title="Editar" style={{ marginRight: 5 }} onClick={e => editarCadastro(e, x)}>
                                                            <i className="fa fa-edit" aria-hidden="true"></i>
                                                        </Button>
                                                        </td>
                                                        <td style={{ width: 60 }}>
                                                            {x.linkAtivo && <Button title="Copiar link da proposta" className="btn-info" style={{ marginRight: 5 }} onClick={e => copiar(e, x)}>
                                                                <i className="fa fa-clone"></i>
                                                            </Button>}
                                                        </td>
                                                        <td>
                                                            <Button title="Cancelar proposta" className="btn-danger" style={{ marginRight: 5 }} onClick={e => cancelar(e, x)}>
                                                                <i className="fa fa-trash"></i>
                                                            </Button></td>
                                                        {TemPixPreenchido(x) &&

                                                            <td>    <Button title="Copiar PIX para pagamento" className="btn btn-pix" style={{ marginRight: 5 }} onClick={e => abrirPix(e, x)}>
                                                                <i className="fa fa-clone"></i>
                                                            </Button>
                                                            </td>

                                                        }
                                                    </td>
                                                </tr>
                                                {permissaoReenvio(x) &&
                                                    <tr>
                                                        <td>    <Button title="Reenviar Link" className="btn-warning" style={{ marginRight: 5 }} onClick={e => reenviarLink(e, x)}>
                                                            <i className="fa fa-redo"></i>
                                                        </Button></td>
                                                    </tr>
                                                }

                                            </table>
                                        }
                                    </td>
                                </tr>
                                {modoDesenv && permissaoDev() &&
                                    <tr>
                                        <td colSpan={2}></td>
                                        <td>
                                            <Button title="Cancelar No GovBR" className="btn-danger" style={{ marginRight: 5 }} onClick={e => cancelarGovBR(e, x)}>
                                                <i className="fa fa-trash"></i>
                                            </Button>
                                        </td>
                                        <td>    <Button title="Reenviar Link" className="btn-warning" style={{ marginRight: 5 }} onClick={e => reenviarLink(e, x)}>
                                            <i className="fa fa-redo"></i>
                                        </Button></td>
                                        <td colSpan={9}>
                                            <span>Token: {x.token}</span>
                                        </td>
                                    </tr >}
                            </>
                        )
                    }
                </tbody>
            </table>
            <MPaging data={dados} onGo={carregar} ref={paginador} />
        </div >
    </>

}
